var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_vm._t("title"),_vm._t("subtitle"),_vm._t("message"),_c('brand-button',{staticClass:"button",on:{"click":_vm.onClick}},[_vm._t("buttonLabel")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }